import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { Player } from "@lottiefiles/react-lottie-player"
import animation from "../../../shared/animations/succeededAnimation.json"
import { Box } from "@mui/system"
import { useMemo } from "react"
import { StandardDialog } from "./StandardDialog"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { TranslationKey } from "../../../modules/localization/translations"

const useStyles = makeStyles()(() => ({
    title: {
        marginTop: "-3rem",
        paddingBottom: "2rem",
        textAlign: "center",
    },
    animationArea: {
        width: "10rem",
        height: "10rem",
        margin: "0 auto",
        marginBottom: "2rem",
    },
}))

export type SuccessDialogType = "deleteBooking" | "extendBooking" | "endBooking" | "deleteOrder"

type SuccessExtendDialogProps = Readonly<{
    open: boolean
    onClose: () => void
    dialogType?: SuccessDialogType
    ordersCount?: number
}>

type DialogContent = {
    value: string
    translationId: TranslationKey
}

export function StandardSuccessDialog({ open, dialogType, onClose, ordersCount = 0 }: SuccessExtendDialogProps) {
    const { classes } = useStyles()

    const title: DialogContent = useMemo(() => {
        const isMultipleOrdersDeletion = ordersCount > 1

        if (dialogType === "extendBooking") {
            return {
                translationId: "user-home-canteen-upcoming-orders-extend-success-dialog-title",
                value: "Booking was extended",
            }
        }
        if (dialogType === "deleteBooking") {
            return {
                translationId: "user-home-canteen-upcoming-orders-delete-success-dialog-title",
                value: "Booking was deleted",
            }
        }
        if (dialogType === "deleteOrder") {
            return {
                translationId: "user-home-canteen-upcoming-orders-delete-order-success-dialog-title",
                value: isMultipleOrdersDeletion ? "Orders were deleted" : "Order was deleted",
            }
        }

        return {
            translationId: "user-home-canteen-upcoming-orders-end-success-dialog-title",
            value: "Booking was ended",
        }
    }, [dialogType, ordersCount])

    return (
        <StandardDialog open={open} onClose={onClose}>
            <LocalizedStrict id={title.translationId} vars={{ ordersCount: ordersCount ?? 0 }}>
                <Typography variant="h4" className={classes.title}>
                    {title.value}
                </Typography>
            </LocalizedStrict>
            <Box className={classes.animationArea}>
                <Player src={animation} autoplay keepLastFrame />
            </Box>
        </StandardDialog>
    )
}
